var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ws-period ws-typo-xs"},[_vm._v(" "+_vm._s(_vm.period % 12 !== 0 ? _vm.$t('wsk.general.period.months', {period: _vm.period}) : _vm.$t('wsk.general.period.years', {period: _vm.period / 12}))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }